import React, { memo, useEffect, useRef, useState } from "react";
import "./style.css";
import DialCodeView from "./dial-code-view";
import NumberInputView from "./number-input-view";
import { isEmpty, isEqual } from "lodash";
import parsePhoneNumber from "libphonenumber-js";
import { getCountryCallingCode } from "libphonenumber-js";

const PhoneNumberInput = ({
  value = "",
  onChange,
  defaultCountry = "",
  countries = [],
  errors = {},
  displayErrors = false,
}) => {
  const [countryCode, setCountryCode] = useState("");
  const [dialCode, setDialCode] = useState("");
  const [nationalNumber, setNationalNumber] = useState("");
  const [showDialCodeView, setShowDialCodeView] = useState(false);
  const innerValueRef = useRef(false);

  const onChangeDialCode = (value) => {
    setCountryCode(value.code);
    setDialCode(value.dialCode);
    setShowDialCodeView(false);
  };

  const onChangeNationalNumber = (value) => {
    setNationalNumber(value);
  };

  useEffect(() => {
    try {
      if (innerValueRef.current) {
        return;
      }
      innerValueRef.current = true;
      const phoneNumber = parsePhoneNumber(value);
      if (!isEmpty(phoneNumber)) {
        setCountryCode(phoneNumber.country);
        setDialCode(`+${phoneNumber.countryCallingCode}`);
        setNationalNumber(phoneNumber.nationalNumber);
      } else {
        setDialCode(`+${getCountryCallingCode("LK")}`);
        setCountryCode(defaultCountry);
      }
    } catch (error) {
      console.log(">>>>> ERROR ", error);
    }
  }, [value, defaultCountry]);

  useEffect(() => {
    const phoneNumber = `${dialCode}${nationalNumber}`;
    if (!isEqual(value, phoneNumber)) {
      onChange(phoneNumber);
      return;
    }
  }, [dialCode, nationalNumber, onChange, value]);

  return showDialCodeView ? (
    <DialCodeView
      onChangeDialCode={onChangeDialCode}
      setShowDialCodeView={setShowDialCodeView}
      countries={countries}
    />
  ) : (
    <NumberInputView
      countryCode={countryCode}
      dialCode={dialCode}
      nationalNumber={nationalNumber}
      setShowDialCodeView={setShowDialCodeView}
      onChangeNationalNumber={onChangeNationalNumber}
      errors={errors}
      displayErrors={displayErrors}
    />
  );
};

export default memo(PhoneNumberInput);
